import { Link } from '@tanstack/react-router'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../auth'
import { SHOW_CANDIDATE } from '../../../user/permission'
import { CampaignSettingsPanelKey } from './campaign-settings-panels'

type CampaignSettingsHeaderActionsProps = {
    campaignId: string
    panelKey: CampaignSettingsPanelKey
}

export function CampaignSettingsHeaderActions({ campaignId, panelKey }: CampaignSettingsHeaderActionsProps) {
    const { t } = useTranslation()
    const { can, hasSubscription } = useAuth()

    if (panelKey === 'missed-candidates') {
        return (
            <Link
                to="/campaigns/$campaignId/settings/candidate-sources"
                params={{ campaignId }}
            >
                <Button>{t('Back to candidate sources')}</Button>
            </Link>
        )
    }

    if (panelKey === 'candidate-sources' && hasSubscription && can(SHOW_CANDIDATE)) {
        return (
            <Link
                to="/campaigns/$campaignId/settings/missed-candidates"
                params={{ campaignId }}
            >
                <Button>{t('Missed candidates')}</Button>
            </Link>
        )
    }

    return null
}
